import React, {useContext, useEffect, useState} from "react";
import LOGO from "../img/LOGO.png";
import LocaleSwitch from "../components/LocaleSwitch";
import {LanguageContext} from "../App";
import {Link} from "react-router-dom";
import {isMobile} from "react-device-detect";
import ReactMarkdown from 'react-markdown'
import {Helmet} from "react-helmet";
import cf from "contentful";
import VESNA from "../img/vesna.png";

const JoinPage = () => {
    const {language} = useContext(LanguageContext)

    const [ groupsList, setGroupsList ] = useState({})
    const [ content, setContent ] = useState({})

    var contentful = require('contentful');
    var client = contentful.createClient({
        space: 'wvu4fbse6d4b',
        accessToken: '_cmrhqx7FzIA5qnfzzcWfjI8dEfX0f-rrKeqsopQP0g' //process.env.REACT_APP_CF_KEY,
    });

    useEffect(() => {
        client.getEntries({
            content_type: 'groups',
            'locale': language.name === 'en' ? 'en-US':'ru',
        }).then(function (entries) {
            setGroupsList(entries)
        })

        client.getEntry('1pBKub8KhqUAKGmCVCTqwD', {'locale': language.name === 'en' ? 'en-US':'ru'}).then((entry)=>{
            setContent(entry)
        })
    })

    const [isMobileMenu, setIsMobileMenu] = useState(false)

    const mmenuShow = () => {
        console.log('mclick')
        setIsMobileMenu(true)
        console.log(content.fields.text_md)
    }
    const mmenuHide = () => {
        setIsMobileMenu(false)
    }

    return (
        <div className='bg-gray-100'>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Хроника протестов в России - Присоединиться</title>
                <meta name="description" content="Список антивоенных движений в России"/>

                {/*Facebook Meta Tags*/}
                <meta property="og:url" content="https://remap-ru.com/join"/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content="Хроника протестов в России - Присоединиться"/>
                <meta property="og:description" content="Список антивоенных движений в России"/>
                <meta property="og:image" content={LOGO}/>

            </Helmet>


            <header className='bg-white'>
                {isMobileMenu &&
                    <>
                        <div className='fixed top-0 z-50 left-0 bg-black/90 z-50 w-full h-screen '>
                            <div className='w-full h-full flex flex-col justify-center'>
                                <div className='m-auto text-white text-center'>

                                    <div className='pb-10'> {language.header.title}</div>
                                    <div className='w-20 mb-4 m-auto text-black'>
                                        <LocaleSwitch/>
                                    </div>

                                    <Link to="/">
                                        <button
                                            className='py-2 px-3  text-sm text-gray-100 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 to-red-700 rounded-sm'>
                                            {language.header.map_button}
                                        </button>
                                    </Link>
                                    <a target='_blank' rel="noreferrer" href="https://t.me/remap_ru">
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                             width="26" height="26"
                                             viewBox="0 0 48 48"
                                             className='m-auto mt-4'
                                        >
                                            <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z">
                                            </path>
                                            <path fill="#fff"
                                                  d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z">
                                            </path>
                                            <path fill="#b0bec5"
                                                  d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z">
                                            </path>
                                            <path fill="#cfd8dc "
                                                  d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z">
                                            </path>
                                        </svg>
                                    </a>
                                    <div className='pt-10'>
                                        <svg onClick={mmenuHide} xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 m-auto" fill="none"
                                             viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
                                        </svg>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </>
                }

                <div className='flex h-16 max-w-5xl m-auto justify-between'>
                    <div className='flex items-center '>
                        <img className='mb-1 ml-4 mr-4' src={LOGO} alt="reMap - Хроника протестов в Росссии"
                             style={{width: '120px', height: '35px'}}
                        />
                        /
                        <a rel="noreferrer" target="_blank" className="h-full" href="https://t.me/vesna_democrat">
                            <img className='mb-1 ml-4' src={VESNA} alt="reMap - Хроника протестов в Росссии"
                                 style={{width: '64px', height: '64px'}}
                            />
                        </a>

                        {
                            !isMobile &&
                            <h1 className='p-3 ml-2 text-base'>
                                {language.header.title}
                                <span className="ml-2 absolute inline-flex rounded-full h-3 w-3 bg-red-500">
                                <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500 animate-ping">
                                </span>
                            </span>
                            </h1>
                        }

                    </div>
                    {
                        isMobile ?
                            <button onClick={mmenuShow}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-4" fill="none"
                                     viewBox="0 0 24 24"
                                     stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h8m-8 6h16"/>
                                </svg>
                            </button>
                            :
                            <div className='flex items-center '>
                                <LocaleSwitch/>
                                <Link to="/">
                                    <button
                                        className='py-2 px-3  text-sm text-gray-100 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 to-red-700 rounded-sm'>
                                        {language.header.map_button}
                                    </button>
                                </Link>
                            </div>
                    }

                </div>
            </header>
            <main className='max-w-5xl m-auto pb-4'>
                <div className='bg-white mt-4 p-4 mx-auto '>
                    <div className='p-2 pb-6'>
                        <h1 className='text-xl'>
                            {language.join_page.group_list.title}
                        </h1>
                        <p className='text-gray-600'>
                            {language.join_page.group_list.desc}
                        </p>
                    </div>
                    <div>
                        <div className="overflow-x-auto px-2">
                            <table className="table-auto w-full">
                                <tbody className="text-sm divide-y divide-gray-100">
                                {!!groupsList.items?.length && groupsList.items.map((group, index) =>
                                    <tr key={index} className={''+ (isMobile && 'flex flex-col flex-no wrap')}>
                                        <td className={"p-2 whitespace-nowrap"}>
                                            <div className="flex items-center">
                                                <div className="w-14 h-14 flex-shrink-0 mr-4">
                                                    <img alt='Grooup logo'
                                                        className="rounded-full w-full border"
                                                        src={group.fields.logo.fields.file.url}
                                                    />
                                                </div>
                                                <div className="font-medium text-gray-800">{group.fields.title}</div>
                                            </div>
                                        </td>
                                        <td className="p-2">
                                            <div className="text-left">
                                                {group.fields.description}
                                            </div>
                                        </td>
                                        <td className="p-2">
                                            <div className={'flex items-center pr-2 '+(isMobile ? 'justify-center':'justify-end')}>
                                                <a target='_blank' rel="noreferrer" href={group.fields.tglink} className='fill-black hover:fill-gray-600'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                         width="30" height="30"
                                                         viewBox="0 0 50 50"
                                                    >
                                                        <path d="M 44.376953 5.9863281 C 43.889905 6.0076957 43.415817 6.1432497 42.988281 6.3144531 C 42.565113 6.4845113 40.128883 7.5243408 36.53125 9.0625 C 32.933617 10.600659 28.256963 12.603668 23.621094 14.589844 C 14.349356 18.562196 5.2382813 22.470703 5.2382812 22.470703 L 5.3046875 22.445312 C 5.3046875 22.445312 4.7547875 22.629122 4.1972656 23.017578 C 3.9185047 23.211806 3.6186028 23.462555 3.3730469 23.828125 C 3.127491 24.193695 2.9479735 24.711788 3.015625 25.259766 C 3.2532479 27.184511 5.2480469 27.730469 5.2480469 27.730469 L 5.2558594 27.734375 L 14.158203 30.78125 C 14.385177 31.538434 16.858319 39.792923 17.402344 41.541016 C 17.702797 42.507484 17.984013 43.064995 18.277344 43.445312 C 18.424133 43.635633 18.577962 43.782915 18.748047 43.890625 C 18.815627 43.933415 18.8867 43.965525 18.957031 43.994141 C 18.958531 43.994806 18.959437 43.99348 18.960938 43.994141 C 18.969579 43.997952 18.977708 43.998295 18.986328 44.001953 L 18.962891 43.996094 C 18.979231 44.002694 18.995359 44.013801 19.011719 44.019531 C 19.043456 44.030655 19.062905 44.030268 19.103516 44.039062 C 20.123059 44.395042 20.966797 43.734375 20.966797 43.734375 L 21.001953 43.707031 L 26.470703 38.634766 L 35.345703 45.554688 L 35.457031 45.605469 C 37.010484 46.295216 38.415349 45.910403 39.193359 45.277344 C 39.97137 44.644284 40.277344 43.828125 40.277344 43.828125 L 40.310547 43.742188 L 46.832031 9.7519531 C 46.998903 8.9915162 47.022612 8.334202 46.865234 7.7402344 C 46.707857 7.1462668 46.325492 6.6299361 45.845703 6.34375 C 45.365914 6.0575639 44.864001 5.9649605 44.376953 5.9863281 z M 44.429688 8.0195312 C 44.627491 8.0103707 44.774102 8.032983 44.820312 8.0605469 C 44.866523 8.0881109 44.887272 8.0844829 44.931641 8.2519531 C 44.976011 8.419423 45.000036 8.7721605 44.878906 9.3242188 L 44.875 9.3359375 L 38.390625 43.128906 C 38.375275 43.162926 38.240151 43.475531 37.931641 43.726562 C 37.616914 43.982653 37.266874 44.182554 36.337891 43.792969 L 26.632812 36.224609 L 26.359375 36.009766 L 26.353516 36.015625 L 23.451172 33.837891 L 39.761719 14.648438 A 1.0001 1.0001 0 0 0 38.974609 13 A 1.0001 1.0001 0 0 0 38.445312 13.167969 L 14.84375 28.902344 L 5.9277344 25.849609 C 5.9277344 25.849609 5.0423771 25.356927 5 25.013672 C 4.99765 24.994652 4.9871961 25.011869 5.0332031 24.943359 C 5.0792101 24.874869 5.1948546 24.759225 5.3398438 24.658203 C 5.6298218 24.456159 5.9609375 24.333984 5.9609375 24.333984 L 5.9941406 24.322266 L 6.0273438 24.308594 C 6.0273438 24.308594 15.138894 20.399882 24.410156 16.427734 C 29.045787 14.44166 33.721617 12.440122 37.318359 10.902344 C 40.914175 9.3649615 43.512419 8.2583658 43.732422 8.1699219 C 43.982886 8.0696253 44.231884 8.0286918 44.429688 8.0195312 z M 33.613281 18.792969 L 21.244141 33.345703 L 21.238281 33.351562 A 1.0001 1.0001 0 0 0 21.183594 33.423828 A 1.0001 1.0001 0 0 0 21.128906 33.507812 A 1.0001 1.0001 0 0 0 20.998047 33.892578 A 1.0001 1.0001 0 0 0 20.998047 33.900391 L 19.386719 41.146484 C 19.35993 41.068197 19.341173 41.039555 19.3125 40.947266 L 19.3125 40.945312 C 18.800713 39.30085 16.467362 31.5161 16.144531 30.439453 L 33.613281 18.792969 z M 22.640625 35.730469 L 24.863281 37.398438 L 21.597656 40.425781 L 22.640625 35.730469 z">
                                                        </path>
                                                    </svg>
                                                </a>
                                            </div>

                                        </td>
                                    </tr>
                                )}


                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='text-right '>
                        <p className='text-sm text-gray-600'>{language.join_page.group_list.footer}</p>
                    </div>
                </div>
                <div className='bg-white mt-4 p-4 mx-auto'>
                    <div className='p-2 pb-4'>
                        <h1 className='text-xl'>
                            {content.fields?.title}
                        </h1>
                        <p className='text-gray-600'>
                            {content.fields?.descript}
                        </p>
                    </div>
                    <div className='p-2'>
                        <ReactMarkdown className='prose max-w-none'>
                            {content.fields?.text_md}
                        </ReactMarkdown>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default JoinPage